
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.378 11.286a21.46 21.46 0 009.336 9.336l3.117-3.117c.382-.383.949-.51 1.445-.34 1.587.524 3.3.808 5.057.808.78 0 1.417.637 1.417 1.416v4.944a1.42 1.42 0 01-1.417 1.417C11.031 25.75.25 14.97.25 1.667.25.887.887.25 1.667.25h4.958c.78 0 1.417.637 1.417 1.417 0 1.77.283 3.47.807 5.057a1.422 1.422 0 01-.354 1.445l-3.117 3.117z","fill":"currentColor"}})])
          )
        }
      }
    